export const DefaultAurumConfigFile = {
  name: "aurum",
  light: {
    colorSchema: {
      background: {
        profileMain: {
          dark:
          "https://themes.elisyanwealth.com/admin-dashboard/aurum/background/dashboard-background.svg", 
          light:
          "https://themes.elisyanwealth.com/admin-dashboard/aurum/background/dashboard-background.svg",
          style: {
            width: 0.15,
          },
        }
      } ,
      logo: {
        secondary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/logo-dark.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/logo-dark.svg',
          style: {
            width: 150,
            height: 50
          },
        },
        primary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/primary-logo-light.svg',
          style: {
            width: 150,
            height: 50
          },
        },
        main: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/main-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/main-logo-dark.svg',
          style: {
            width: 170,
            height: 75
          },
        },
      },
      inputs: {
        secondary: {
          background: "#DBC7AC",
          text: "#FFFFFF",
          outline: "#DBC7AC",
          icon: "#FFFFFF",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#FFFFFF", "#FFFFFF"],
          text: "#6B7A8E",
          outline: "#6B7A8E",
          icon: "#FFFFFF",
        },
      },

      buttons: {
        secondary: {
          background: "#FFFFFF",
          text: "#777777",
          outline: "#777777",
          icon: "#313131",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#313131", "#313131"],
          text: "#FFFFFF",
          outline: "#313131",
          icon: "#FFFFFF",
        },
      },
      colors: {
        secondary: "#DFC4AC",
        progressBarDashboard: ["#FCBE5A", "#57370D"],
        secondaryBackground: "#F6F6F6",
        mainBackground: "#FFFFFF",
        profilePictureStroke: "#FFE998",
        text: "#949494",
        mainText: "#000000",
        primary: "#313131",
        secondaryText: "#6B6B6B",
        thirdText: "#FFE998",
        inputBackground: "#FFFFFF",
        thirdBackground: "#E7E6E6",
      },
    },
  },
  dark: {
    colorSchema: {
      background: {
        profileMain: {
          dark:
          "https://themes.elisyanwealth.com/admin-dashboard/aurum/background/dashboard-background.svg", 
          light:
          "https://themes.elisyanwealth.com/admin-dashboard/aurum/background/dashboard-background.svg",
          style: {
            width: 0.15,
          },
        }
      } ,
      logo: {
        secondary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/logo-dark.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/logo-dark.svg',
          style: {
            width: 150,
            height: 50
          },
        },
        primary: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/primary-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/primary-logo-light.svg',
          style: {
            width: 150,
            height: 50
          },
        },
        main: {
          light: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/main-logo-light.svg',
          dark: 'https://themes.elisyanwealth.com/admin-dashboard/aurum/logo/main-logo-dark.svg',
          style: {
            width: 170,
            height: 75
          },
        },
      },
      inputs: {
        secondary: {
          background: "#DBC7AC",
          text: "#FFFFFF",
          outline: "#DBC7AC",
          icon: "#FFFFFF",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#FFFFFF", "#FFFFFF"],
          text: "#6B7A8E",
          outline: "#6B7A8E",
          icon: "#FFFFFF",
        },
      },
      buttons: {
        secondary: {
          background: "#DBC7AC",
          text: "#6B7A8E",
          outline: "#DBC7AC",
          icon: "#FFFFFF",
        },
        plus: {
          background: ["#6B7A8E", "#6B7A8E"],
          text: "#FFE300",
          outline: "#6B7A8E",
          icon: "#FFE300",
        },
        primary: {
          background: ["#FFE998", "#FFE998"],
          text: "#6B7A8E",
          outline: "#6B7A8E",
          icon: "#FFFFFF",
        },
      },
      colors: {
        secondary: "#6B7A8E",
        progressBarDashboard: ["#FFE998", "#57370D"],
        secondaryBackground: "#6B7A8E",
        mainBackground: "#6B7A8E",
        profilePictureStroke: "#FFE998",
        text: "#FFFFFF",
        mainText: "#FFFFFF",
        primary: "#595959",
        secondaryText: "#6B6B6B", //'#DBC7AC',
        thirdText: "#FFE998",
        inputBackground: "#FFFFFF",
        thirdBackground: "#E7E6E6",
      },
    },
  },
  text:{
    en: {
      welcomeScreen: "Securely Track your Global Wealth",
    signupScreen: "Securely Track your Global Wealth",
    loginScreen: "Welcome to Aurum Private Office",
    loginScreenRegister: "New to Aurum Private Office?",
    welcomeModal: "Securely Track your Global Wealth",
    },
    fr:{
      welcomeScreen: "Suivez votre patrimoine mondial en toute sécurité",
      signupScreen: "Suivez votre patrimoine mondial en toute sécurité",
      loginScreen: "Bienvenue chez Aurum Private Office",
      loginScreenRegister: "Nouveau chez Aurum Private Office ?",
      welcomeModal: "Suivez votre patrimoine mondial en toute sécurité",
    }
  }
};
